import React from 'react';
import { RiDeleteBin6Line } from '@react-icons/all-files/ri/RiDeleteBin6Line';
import './styles.scss';
import { DropdownComponent } from 'Components/molecules';
import { ACTION_DATA_TYPES, ACTION_ICONS, ActionDataType, ActionEntry } from 'Core-utils/types/rules.types';

export interface ActionRowProps {
    entry: ActionEntry;
    label: string;
    onChange: (patch: Partial<ActionEntry>) => void;
    onRemove: () => void;
    canRemove: boolean;
}

const ActionRow = ({ entry, onChange, onRemove, canRemove }: ActionRowProps) => (
    <div className="rb-action-row">
        <span className="rb-action-row__icon">{ACTION_ICONS[entry.actionType] ?? '•'}</span>
        <div className="rb-action-row__dropdown rb-dropdown-wrap" style={{ flex: 1 }}>
            <DropdownComponent
                value={ACTION_DATA_TYPES.find((a) => a.value === entry.actionType)?.label ?? ''}
                dropDownItems={ACTION_DATA_TYPES.map((a) => ({ id: a.value, displayValue: a.label, value: a.value }))}
                onChange={(v) => onChange({ actionType: (v ?? 'ADD_TAG') as ActionDataType })}
                variant="filled"
            />
        </div>
        {canRemove && (
            <button type="button" className="rb-action-row__del" onClick={onRemove} title="Remove action">
                <RiDeleteBin6Line size={15} />
            </button>
        )}
    </div>
);

export default ActionRow;
